import { render, staticRenderFns } from "./ChartVolumePerProduk.vue?vue&type=template&id=20a5044b"
import script from "./ChartVolumePerProduk.vue?vue&type=script&lang=js"
export * from "./ChartVolumePerProduk.vue?vue&type=script&lang=js"
import style0 from "./ChartVolumePerProduk.vue?vue&type=style&index=0&id=20a5044b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports